import { GiftItemType } from '@models/gift';
import { useFlow } from '@router/stackflow';
import { useContext, useState } from 'react';

import PpCardListContext from '../context/PpCardListContext';

function useOnPpCardClick() {
    const { type, giftItemId } = useContext(PpCardListContext);
    const isGift = type === 'GIFT';
    const { push } = useFlow();

    return (id: string) => {
        if (isGift) {
            push('GiftOrderActivity', {
                giftItemId: giftItemId!,
                type: GiftItemType.CASH,
                qty: 1,
                giftCardImageId: id,
            });
        } else {
            push('PrepaidCardImageActivity', { prepaidCardImageId: id });
        }
    };
}

export default useOnPpCardClick;
